<template>
  <div id="app" class="w-full min-h-screen overflow-hidden bg-white sm:bg-gray-50">
    <!-- Loading Order -->
    <div v-if="pageStatus === 'orderLoading'" class="w-full min-h-screen flex items-center justify-center">
      <div class="spinner mr-6"></div>
      <div>Loading Order Details...</div>
    </div>

    <!-- Loaded -->
    <div v-if="pageStatus === 'orderLoaded'" class="bg-white max-w-md mx-auto p-6 sm:my-6 sm:p-8 sm:shadow sm:rounded-lg">
      <div class="block">
        <div class="mb-6 text-center">
          <img v-if="retailBrand === 'surterra'" :src="retailLogo" width="250" class="inline-block" />
          <div v-if="retailBrand === 'neta'" class="bg-neta-gray rounded-lg p-6">
            <img :src="retailLogo" width="100" class="inline-block" />
          </div>
        </div>
        <div class="mb-6">
          <h1 class="text-xl sm:text-2xl font-lg mb-2 font-semibold">Order Details</h1>
          <ul>
            <li class="flex justify-between"><span class="font-medium">Order Number:</span> <span>{{ paymentRequest.order_number }}</span></li>
            <li class="flex justify-between"><span class="font-medium">Order Type:</span> <span class="capitalize">{{ paymentRequest.order_type }}</span></li>
            <li class="flex justify-between"><span class="font-medium">Ordered On:</span> <span>{{ paymentRequest.order_date }}</span></li>
            <li class="flex justify-between"><span class="font-medium">Name:</span> {{ paymentRequest.first_name + ' ' + paymentRequest.last_name }}</li>
            <li class="flex justify-between"><span class="font-medium">Amount Due:</span> {{ formatedAmount }}</li>
            <li class="flex justify-between" v-if="paymentRequest.order_type ==='pickup'"><span class="font-medium">Pickup Location:</span> {{ paymentRequest.facility.name }}</li>
          </ul>
        </div>
        <div>
          <h1 class="text-xl sm:text-2xl font-lg mb-2 font-semibold">Choose Payment Method</h1>
          <!-- <p class="mb-6">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce risus mi, sagittis et pharetra et.</p> -->
          <div v-if="paymentRequest.order_type ==='pickup'" class="flex">
            <button @click="paymentMethod = 'canpay'" :class="(paymentMethod === 'canpay') ? 'border-blue-500' : 'border-transparent'" class="w-auto flex-grow py-2 mr-4 shadow-xl rounded-lg flex flex-col justify-center mb-8 items-center border-4 focus:outline-none">
              <img src="../assets/images/CanPay-Logo.png" width="75" />
              <p class="font-medium text-xs pt-4">
                <span class="italic font-bold">GOOD 2 GO</span>
              </p>
            </button>
            <button @click="paymentMethod = 'in-store'" :class="(paymentMethod === 'in-store') ? 'border-blue-500' : 'border-transparent'" class="w-auto flex-grow py-2 shadow-xl rounded-lg flex flex-col justify-center mb-8 items-center border-4 focus:outline-none">
              <img :src="retailLogo" style="height: 25px;" />
              <p class="font-medium text-xs pt-2">
                <span>Pay In Store</span><br>
                <span class="block pt-2 italic font-bold">Non-Express Pickup</span>
              </p>
            </button>
          </div>
          <div v-if="paymentRequest.order_type ==='delivery'" class="flex">
            <button @click="paymentMethod = 'canpay'" :class="(paymentMethod === 'canpay') ? 'border-blue-500' : 'border-transparent'" class="w-auto flex-grow py-2 mr-4 shadow-xl rounded-lg flex flex-col justify-center mb-8 items-center border-4 focus:outline-none">
              <img src="../assets/images/CanPay-Logo.png" width="75" />
            </button>
            <button @click="paymentMethod = 'in-store'" :class="(paymentMethod === 'in-store') ? 'border-blue-500' : 'border-transparent'" class="w-auto flex-grow py-2 shadow-xl rounded-lg flex flex-col justify-center mb-8 items-center border-4 focus:outline-none">
              <img :src="retailLogo" style="height: 25px;" />
              <p class="font-medium text-xs pt-2">
                <span>Pay At Delivery</span>
              </p>
            </button>
          </div>
          <ValidationObserver ref="paymentForm" tag="form" method="post" action="" class="mb-6" @submit.prevent="processPayment()">
            <!-- CanPay Token -->
            <ValidationProvider v-if="paymentMethod === 'canpay'" v-slot="{ errors, classes }" vid="canpay-token" rules="required" tag="div" class="form-field-container">
              <div :class="classes">
                <form-label for="canpay-token">Payment Pin</form-label>
                <form-text id="canpay-token" v-model="canpayToken" name="canpay-token" aria-label="payment pin" />
                <form-help v-if="errors">{{ errors[0] }}</form-help>
              </div>
              <p class="mt-2 text-sm">Don't have a CanPay account? <a href="https://www.canpaydebit.com/" target="_blank" class="text-blue-500 font-bold">Click here to get started.</a></p>
            </ValidationProvider>

            <!-- Error Banner -->
            <div v-if="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 mb-4 rounded-md">{{ error }}</div>

            <!-- Submit Button -->
            <div class="form-field-container">
              <button :class="{ 'loading': formLoadingStatus }" type="submit" class="w-full text-center py-4 font-semibold rounded-lg shadow-xl text-white bg-blue-500 hover:bg-blue-600 focus:outline-none transition duration-150 ease-in-out">{{ submitButtonText }}</button>
            </div>
          </ValidationObserver>
          <p class="mb-4 text-sm text-center">{{ finePrint }}</p>
          <p class="italic text-sm text-center mb-4">Have a question? Give us a call at <a href="tel:850-391-5455">(850) 391-5455</a>.</p>
          <p class="text-xs text-center font-medium"><a href="https://www.surterra.com/customer-care/payment-options/ " target="_blank" class="text-blue-500 hover:underline">FAQ</a> | <a href="https://www.surterra.com/terms-of-service/" target="_blank" class="text-blue-500 hover:underline">Terms of Use</a> | <a href="https://www.surterra.com/privacy-policy/" target="_blank" class="text-blue-500 hover:underline">Privacy Policy</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import formLabel from '../components/forms/Label.vue';
import formText from '../components/forms/Text.vue';
import formHelp from '../components/forms/Help.vue';

const surterraLogo = require('../assets/images/SW-Logo.png');
const netaLogo = require('../assets/images/NETA-Logo.png');

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    formLabel,
    formText,
    formHelp,
  },
  data() {
    return {
      pageTitle: 'Loading...',
      pageStatus: 'orderLoading',
      formLoadingStatus: false,
      paymentRequest: null,
      retailBrand: null,
      paymentMethod: 'canpay',
      canpayToken: null,
      error: null,
    };
  },
  metaInfo() {
    return { title: this.pageTitle };
  },
  computed: {
    retailLogo() {
      if (this.retailBrand === 'surterra') {
        return surterraLogo;
      }

      if (this.retailBrand === 'neta') {
        return netaLogo;
      }

      return null;
    },
    formatedAmount() {
      if (this.paymentRequest !== null) {
        return (this.paymentRequest.amount / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      }
      return '$0.00';
    },
    submitButtonText() {
      // CanPay
      if (this.paymentMethod === 'canpay') {
        return `Pay ${this.formatedAmount}`;
      }

      // In-Store
      if (this.paymentMethod === 'in-store') {
        if (this.paymentRequest.order_type === 'pickup') {
          return 'Pay In Store';
        }

        if (this.paymentRequest.order_type === 'delivery') {
          return 'Pay At Delivery';
        }
      }

      return 'Error';
    },
    finePrint() {
      if (this.paymentRequest.order_type === 'pickup') {
        return 'Pre-paid orders that are not picked up within 48 hours will be returned. A store credit will be issued to the customer and any dispensations will be reversed. Unpaid orders that are not picked up by 8pm will be cancelled.';
      }

      if (this.paymentRequest.order_type === 'delivery') {
        return 'If a delivery order is not deliverable the order will be returned and any dispensations reversed. If the order was prepaid a store credit will be issued to the customer.';
      }

      return 'Error';
    },
  },
  beforeMount() {
    const self = this;

    axios
      .get(
        `${process.env.VUE_APP_PARALLEL_API_BASE_URL}/payment-requests/token/${self.$route.query.token}`,
      )
      .then((response) => {
        if (response.data.status === 'paid') {
          this.$router.push('not-found');
        }
        else {
          if (response.data.retail_brand === 'surterra') {
            self.pageTitle = 'Surterra Pre-Payment';
          }
          else if (response.data.retail_brand === 'neta') {
            self.pageTitle = 'Neta Pre-Payment';
          }

          self.pageStatus = 'orderLoaded';
          self.paymentRequest = response.data;
          self.retailBrand = response.data.retail_brand;
        }
      })
      .catch((error) => {
        if (RegExp('4\\d\\d').test(error.response.status)) { // Match any 4xx error
          this.$router.push('not-found');
        }
      });
  },
  methods: {
    async processPayment() {
      const self = this;

      if (self.formLoadingStatus === false) {
        self.formLoadingStatus = true;

        const isValid = await self.$refs.paymentForm.validate();

        // Failed Validation
        if (!isValid) { // Failed Validation
          self.formLoadingStatus = false;
        }

        // Passed Validation
        else if (this.paymentMethod === 'canpay') {
          // Canpay Token Length Validator
          if (self.canpayToken.length < 7) {
            self.$refs.paymentForm.setErrors({
              'canpay-token': 'Invalid Payment Pin. The CanPay Payment Pin is 7 or more characters in length and can be obtained after logging into the CanPay app.',
            });

            self.formLoadingStatus = false;
          }
          else {
            axios.post(
              `${process.env.VUE_APP_PARALLEL_API_BASE_URL}/payment-requests/token/${self.$route.query.token}/payment`,
              { canpay_token: self.canpayToken },
            )
              .then(() => {
                self.$router.push({ name: 'thankYou', params: { type: self.paymentRequest.order_type } });
              })
              .catch((error) => {
                if (error.response.data.status === 'canpay error' && error.response.data.message.includes('Invalid Token:')) {
                  self.$refs.paymentForm.setErrors({
                    'canpay-token': 'Invalid Payment Pin',
                  });
                }
                else if (error.response.data.status === 'canpay error') {
                  self.error = `CanPay Error: ${error.response.data.message}`;
                }
                else {
                  self.$router.push('not-found');
                }

                self.formLoadingStatus = false;
              });
          }
        }
        else if (self.paymentMethod === 'in-store') {
          self.$router.push({ name: 'thankYou', params: { type: self.paymentRequest.order_type } });
        }
      }
    },
  },
};
</script>
